/**
 * Proxemics brand mark. Files live in /public so they're served at root paths.
 *
 * variant:
 *   'full'       — 'proxportal' wordmark + target (white/orange). For DARK
 *                  backgrounds like the sidebar header.
 *   'full-color' — 'proxportal' wordmark + target in full color (orange +
 *                  dark gray). For LIGHT backgrounds like the mobile top bar.
 *   'mark'       — target only (gray/orange). Neutral, works on ANY background.
 *                  Used on the login page (white) but suitable anywhere a
 *                  compact mark reads better than a wordmark.
 */
export default function Logo({ variant = 'full', size = 32, alt = 'Proxemics Portal' }) {
  const src =
    variant === 'mark'
      ? '/Proxemics-Target.png'
      : variant === 'full-color'
        ? '/ProxPortal-FullColor.png'
        : '/ProxPortal.png';
  return (
    <img
      src={src}
      alt={alt}
      style={{ display: 'block', height: size, width: 'auto' }}
    />
  );
}
